// Theme configurations
export const THEMES = {
  light: {
    theme: "light",
  },
  dark: {
    theme: "dark",
  },
  custom: {
    theme: "custom",
    colors: {
      mode: "dark",
      common: {
        black: "#000",
        white: "#fff",
      },
      primary: {
        main: "#fff",
      },
      secondary: {
        main: "rgba(255, 255, 255, 0.5)",
      },
      error: {
        main: "#d32f2f",
        light: "#ef5350",
        dark: "#c62828",
        contrastText: "#fff",
      },
      warning: {
        main: "#ed6c02",
        light: "#ff9800",
        dark: "#e65100",
        contrastText: "#fff",
      },
      info: {
        main: "#0288d1",
        light: "#03a9f4",
        dark: "#01579b",
        contrastText: "#fff",
      },
      success: {
        main: "#2e7d32",
        light: "#4caf50",
        dark: "#1b5e20",
        contrastText: "#fff",
      },
      grey: {
        "50": "#212121",
        "100": "#2a2a2d",
        "200": "#353538",
        "300": "#424242",
        "400": "#525252",
        "500": "#616161",
        "600": "#757575",
        "700": "#9e9e9e",
        "800": "#bdbdbd",
        "900": "#e0e0e0",
        A100: "#2a2a2d",
        A200: "#353538",
        A400: "#525252",
        A700: "#9e9e9e",
      },
      contrastThreshold: 3,
      tonalOffset: 0.2,
      text: {
        primary: "#fff",
        secondary: "rgba(255, 255, 255, 0.5)",
        disabled: "rgba(255, 255, 255, 0.38)",
      },
      divider: "rgba(255, 255, 255, 0.12)",
      background: {
        default: "#262629",
        paper: "#303034",
      },
      action: {
        active: "rgba(255, 255, 255, 0.54)",
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.26)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24,
      },
    },
  },
} as const;

// Test parameters provided by user - extracted as separated variables for demo
export const TEST_POINT_ID = "01979ec7-88ff-72ab-9c22-d043ea16aa14";

// SDK Configuration
export const SDK_CONFIG = {
  // URLs для разных окружений
  DEV_URL: "http://localhost:5002/preorder.umd.js",
  PROD_URL: "https://pre-order-window-sdk.dev.restomenu.cc/preorder.umd.js",

  // Server URLs для разных окружений
  DEV_SERVER_URL: "http://localhost:5002",
  PROD_SERVER_URL: "https://external-menu.dev.restomenu.cc",
} as const;

/**
 * Получить URL для загрузки Preorder SDK в зависимости от окружения
 * @returns URL для загрузки SDK
 */
export const getSDKUrl = (): string => {
  // Проверяем окружение по нескольким критериям
  const isDev =
    process.env.NODE_ENV === "development" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.port === "5002";

  return isDev ? SDK_CONFIG.DEV_URL : SDK_CONFIG.PROD_URL;
};

/**
 * Получить отображаемый URL SDK для UI
 * @returns Отображаемый URL с указанием окружения
 */
export const getDisplaySDKUrl = (): string => {
  const isDev =
    process.env.NODE_ENV === "development" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.port === "5002";

  return isDev
    ? `${SDK_CONFIG.DEV_URL} (dev)`
    : `${SDK_CONFIG.PROD_URL} (prod)`;
};

/**
 * Получить server URL для конфигурации SDK
 * @returns Server URL для API запросов
 */
export const getServerUrl = (): string => {
  const isDev =
    process.env.NODE_ENV === "development" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.port === "5002";

  return isDev ? SDK_CONFIG.DEV_SERVER_URL : SDK_CONFIG.PROD_SERVER_URL;
};

/**
 * Получить информацию об окружении
 * @returns Объект с информацией об окружении
 */
export const getEnvironmentInfo = () => {
  const isDev =
    process.env.NODE_ENV === "development" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.port === "5002";

  return {
    isDev,
    environment: isDev ? "development" : "production",
    hostname: window.location.hostname,
    port: window.location.port,
    nodeEnv: process.env.NODE_ENV,
    sdkUrl: getSDKUrl(),
    serverUrl: getServerUrl(),
    displayUrl: getDisplaySDKUrl(),
  };
};
